import { SummaryRow } from '../../../Summary/SummaryRow';
import { IRisk } from '../../../../types';
import { isFundingRisk } from '../../../../utilities/risks';

interface Props {
  id: string;
  showRisks: boolean;
  risk: IRisk['financeDocsRisk']['birthCertificate'];
  isLegalDocument: boolean;
  hasAllNames: boolean;
  inEnglish: boolean;
  hasTranslation: boolean;
  uploadedBy?: string;
}

export default function BirthCertificate({
  id,
  showRisks,
  risk,
  isLegalDocument,
  hasAllNames,
  inEnglish,
  hasTranslation,
  uploadedBy,
}: Props) {
  if (isLegalDocument === undefined && hasAllNames === undefined) {
    return <div>Uploaded by {uploadedBy ? uploadedBy : 'University'}</div>;
  }
  return (
    <>
      <SummaryRow
        key="isLegalDocument"
        label="Is Legal Document"
        fullLabel="Are you uploading a scan of the original legal document?"
        value={isLegalDocument ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risk, 'isLegalDocument', id)}
      />

      <SummaryRow
        key="hasAllNames"
        label="Has All Names"
        fullLabel="Does the document include your name and the name of the parent/guardian providing funds?"
        value={hasAllNames ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risk, 'hasAllNames', id)}
      />

      <SummaryRow
        key="inEnglish"
        label="English"
        fullLabel="Is the letter in English?"
        value={inEnglish ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risk, 'inEnglishOrHasTranslation', id)}
      />

      {!inEnglish && (
        <SummaryRow
          key="hasTranslation"
          label="Has Translation"
          fullLabel="Have you provided an English translation of the letter?"
          value={hasTranslation ? 'Yes' : 'No'}
          isRisk={showRisks && isFundingRisk(risk, 'inEnglishOrHasTranslation', id)}
        />
      )}
    </>
  );
}
